//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ActionBase, Illustration } from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'
import { mapGetters } from 'vuex'

import { COUNTRIES } from '@config/constants'

// Note that before registering new URLs to this configuration, you should
// also download and store associated assets in `app/static/img/social`.

// assets may be found here: https://www.figma.com/file/jC2mtHRgj5YEWRLSQYfKHq/04.-Assets?node-id=1%3A852

export const STORE_COUNTRIES = [
  COUNTRIES.AT,
  COUNTRIES.BE,
  COUNTRIES.DE,
  COUNTRIES.ES,
  COUNTRIES.FI,
  COUNTRIES.FR,
  COUNTRIES.GR,
  COUNTRIES.IT,
  COUNTRIES.NL,
  COUNTRIES.GB,
  COUNTRIES.IE,
  COUNTRIES.US,
  COUNTRIES.PT,
  COUNTRIES.GR,
  COUNTRIES.SK,
]

export const GOOGLE_STORE_BASE_URL =
  'https://app.backmarket.com/logo_stores?$fallback_url=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.backmarket&~channel=backmarket&~feature=referral'
export const APPLE_STORE_BASE_URL =
  'https://app.backmarket.com/logo_stores?$fallback_url=https%3A%2F%2Fapps.apple.com%2Fapp%2Fback-market-achat-vente%2Fid1458344336&~channel=backmarket&~feature=referral'

const googleStoreUrl = (country) => (campaign) =>
  campaign
    ? `${GOOGLE_STORE_BASE_URL}&~placement=${country.toLowerCase()}&~campaign=${campaign}`
    : `${GOOGLE_STORE_BASE_URL}&~placement=${country.toLowerCase()}`

const appleStoreUrl = (country) => (campaign) =>
  campaign
    ? `${APPLE_STORE_BASE_URL}&~placement=${country.toLowerCase()}&~campaign=${campaign}`
    : `${APPLE_STORE_BASE_URL}&~placement=${country.toLowerCase()}`

const STORE_URLS = Object.values(STORE_COUNTRIES).reduce((config, country) => {
  return {
    ...config,
    [country]: {
      google: (campaign) => googleStoreUrl(country)(campaign),
      apple: (campaign) => appleStoreUrl(country)(campaign),
    },
  }
}, {})

export default {
  components: {
    ActionBase,
    Illustration,
  },

  props: {
    campaign: {
      type: String,
      default: null,
    },
  },

  computed: {
    ...mapGetters({
      country: 'config/country',
    }),

    buttons() {
      if (!(this.country in STORE_URLS)) return []

      return [
        {
          key: 'google-play',
          url: STORE_URLS[this.country].google(this.campaign),
          img: this.$static(`/img/socials/${this.country}/google-play.svg`),
          alt: 'Google Play',
          class: 'inline-block h-[4rem]',
          width: 135,
          height: 40,
        },
        {
          key: 'app-store',
          url: STORE_URLS[this.country].apple(this.campaign),
          img: this.$static(`/img/socials/${this.country}/apple-store.svg`),
          alt: 'Apple Store',
          class: 'inline-block h-[4rem] ml-2',
          width: 127,
          height: 40,
        },
      ].filter((button) => button.url)
    },

    visible() {
      return !isEmpty(this.buttons)
    },
  },
}
